<template>
    <div ref="weSingleUpload">
        <div class="weact-upload" :class="classWrapper">
            <input type="file" ref="file" @change="handleFileUpload()" />
            <div class="text" :class="{ 'no-file': file == null }">
                <span>{{ file == null ? placeholder : file.name }}</span>
                <i class="pe-7s-upload" v-if="file == null"></i>
                <i class="pe-7s-portfolio" v-if="file != null"></i>
            </div>
        </div>
        <span :class="classError" v-if="error.fileType">{{ fileTypeErrorText }}</span>
        <span :class="classError" v-if="error.fileSize">{{ fileSizeErrorText }}</span>
    </div>
</template>

<script>
export default {
    props: {
        placeholder: String,
        classWrapper: String,
        classError: String,
        fileTypeErrorText: String,
        fileTypeAllow: Array,
        fileSizeErrorText: String,
        fileSizeAllow: Number
    },
    data() {
        return {
            file: null,
            error: this.initValidateFile()
        };
    },
    watch: {
        file(curr) {
            this.$emit('input', curr);
        },
    },
    methods: {
        initValidateFile() {
            return { fileType: false, fileSize: false };
        },
        handleFileUpload() {
            var input = this.$refs.file.files[0];

            this.file = null;
            this.error = this.initValidateFile();

            if (this.validateFileType(input) && this.validateFileSize(input)) {
                this.file = this.$refs.file.files[0];
            }
        },
        validateFileType(input) {
            var valid = false;

            if (input != '' && input != null && typeof input != 'undefined') {
                if (this.fileTypeAllow.length > 0) {
                    for (var index = 0; index < this.fileTypeAllow.length; index++) {
                        if (input.type === this.fileTypeAllow[index]) {
                            valid = true;
                        }
                    }

                    if (!valid) {
                        this.error.fileType = true;
                    }
                }
                else {
                    valid = true;
                }
            }
            else {
                valid = true;
            }

            return valid;
        },
        validateFileSize(input) {
            var valid = false;

            if (input != '' && input != null && typeof input != 'undefined') {
                if (this.fileSizeAllow != '' && this.fileSizeAllow != null && typeof this.fileSizeAllow != 'undefined') {
                    if (this.fileSizeAllow >= input.size) {
                        valid = true;
                    }

                    if (!valid) {
                        this.error.fileSize = true;
                    }
                }
                else {
                    valid = true;
                }
            }
            else {
                valid = true;
            }

            return valid;
        }
    }
};
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.weact-upload {
    position: relative;
    display: inline-block;
    width: 100%;

    input {
        position: absolute;
        z-index: 2;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0;
        opacity: 0;
        cursor: pointer;
    }
    
    .text {
        position: relative;
        cursor: pointer;
        z-index: 1;
        width: 100%;
        height: auto;
        margin: 0;
        padding: 5px 32px 5px 5px;
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        color: #000;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 0;

        &.no-file {
            color: #ccc !important;
        }

        span {
            display: block;
            white-space: nowrap;
            overflow: hidden;
        }

        i {
            position: absolute;
            top: 25%;
            right: 5px;
            font-size: 22px;
            color: #ccc;
        }
    }
}
</style>